"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var firefly_utilities_ts_1 = require("firefly-utilities-ts");
var DataLayerInterceptor = /** @class */ (function () {
    function DataLayerInterceptor() {
    }
    DataLayerInterceptor.prototype.apply = function (json) {
        var interceptorJSON = {};
        return firefly_utilities_ts_1.Utilities.extend(json, interceptorJSON);
    };
    return DataLayerInterceptor;
}());
exports.default = DataLayerInterceptor;
